import { ErrorTypes } from '@shared/models/enums/http'
import { Nullable } from '@shared/models/types/primary'

export const isServerError = (error?: Nullable<Error>) => {
  if (error && error?.name === ErrorTypes.SERVER) {
    return error?.message || null
  }
  return null
}

export const isNetworkError = (error?: Nullable<Error>) => {
  if (error && error?.name === ErrorTypes.NETWORK) {
    return error?.message || null
  }
  return null
}
